import { StyleFn } from '..'

export const Drawer: StyleFn = ({ color, elevation }) => ({
  root: {
    position: 'fixed',
    zIndex: elevation.zindex.drawer,
    boxShadow: elevation.level3,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    height: '100vh',
    outline: 0,
  },
  modal: {
    zIndex: elevation.zindex.drawer,
  },
  _horizontal: {
    width: '100%',
    maxWidth: '100vw',
    height: 'auto',
  },
  _top: {
    top: 0,
    left: 0,
  },
  _bottom: {
    bottom: 0,
    left: 0,
  },
  _left: {
    top: 0,
    left: 0,
  },
  _right: {
    top: 0,
    right: 0,
  },
  _dark: {
    backgroundColor: color.background.primary.onDark,
    color: color.palette.white,
  },
  _light: {
    backgroundColor: color.background.primary.onWhite,
  },
})
